module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container bg-none block-control"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2 back-remove"
  }, [_c('button', {
    staticClass: "button-back",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  }, [_c('span', [_vm._v("Назад")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-9 ideas-list"
  }, [_c('div', {
    staticClass: "remove-link"
  }), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Расширенный поиск")]), _vm._v(" "), (_vm.searchResults.byTitle) ? _c('div', [_c('p', {
    staticClass: "title-similar"
  }, [_vm._v("Похожие темы")]), _vm._v(" "), _vm._l((_vm.searchResults.byTitle), function(idea) {
    return _c('Idea', {
      attrs: {
        "idea": idea
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.searchResults.byDesc) ? _c('div', [_c('p', {
    staticClass: "text-up"
  }, [_vm._v("Упоминания в тексте")]), _vm._v(" "), _vm._l((_vm.searchResults.byDesc), function(idea) {
    return _c('Idea', {
      attrs: {
        "idea": idea
      }
    })
  })], 2) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-581d8776","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPage.vue
// module id = 113
// module chunks = 0